export default __webpack_public_path__ + "static/media/Ai_chat_black.d3d76ce1.svg";